module.exports = __webpack_public_path__ + "img/TIMES.8862aeda.svg";